<template>
  <v-sheet class="mx-auto">
    <v-skeleton-loader
      v-if="loading"
      class="mx-auto"
      height="150"
      type="image"
    />
    <v-slide-group
      v-else
      v-model="selected"
      class="pa-3"
      show-arrows
      center-active
      :disabled="disabled"
    >
      <v-slide-item
        v-for="item in items"
        :key="item.id"
        v-slot="{ active, toggle }"
        :value="item.value"
      >
        <v-card
          class="mx-4 my-3 rounded-xl card-border-red"
          rounded="5"
          width="280"
          :class="[
            active ? 'bg-main-color text-white' : '',
            disabled ? 'cursor-not-allowed' : '',
          ]"
          :style="{
            pointerEvents: disabled ? 'none' : 'auto',
            opacity: disabled ? 0.5 : 1,
          }"
          :tabindex="disabled ? -1 : 0"
          @click="handleCardClick(toggle, $event)"
        >
          <v-card-title class="text-body-2">
            {{ item.name }} <br />
            <span class="subtitle-2">{{
              `${item.territory_description}`
            }}</span>
          </v-card-title>

          <v-card-text
            class="mt-auto text-black"
            :class="{ 'text-white': active }"
          >
            <v-row no-gutters>
              <v-col cols="6">
                <div class="d-flex flex-column align-items-baseline">
                  <span class="caption">Importe</span>
                  <span class="subtitle-2"
                    >{{ formatNumber(item.orders_amount, '$', 0) }}
                  </span>
                  <span class="caption"
                    >N° Pedidos:
                    <b>{{ formatNumber(item.orders_count, '', 0) }}</b></span
                  >
                </div>
              </v-col>
              <v-col cols="6">
                <div class="d-flex flex-column align-items-left-start">
                  <span class="caption">Facturado</span>
                  <span class="subtitle-2"
                    >{{ formatNumber(item.orders_billed_amount, '$', 0) }}
                  </span>
                  <span class="caption"
                    >N° Pedidos:
                    <b>{{
                      formatNumber(item.orders_billed_count, '', 0)
                    }}</b></span
                  >
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-slide-item>
    </v-slide-group>
  </v-sheet>
</template>

<script>
  import numbersFormats from '@/mixins/numbersFormats';

  export default {
    name: 'UserSlider',
    mixins: [numbersFormats],
    props: {
      items: {
        type: Array,
        default: () => [],
      },
      value: {
        type: [String, Number],
        required: true,
      },
      loading: Boolean,
      hasErrors: Boolean,
      disabled: Boolean,
    },
    computed: {
      selected: {
        set(newValue) {
          this.$emit('input', newValue);
        },
        get() {
          return this.value;
        },
      },
    },
    methods: {
      handleCardClick(toggle, event) {
        if (this.disabled) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        toggle();
      },
    },
  };
</script>
